module.exports = __webpack_public_path__ + "img/jhyx_logo.feade08b.png";